import './styles.scss'

export default function QuoteBlock({ quote, subline }) {
  return (
    <div className={'dhsv-quote-block'} data-scroll>
      <div className="row justify-content-center">
        <div className="col-1 col-quote">
          <span className={'quote'}>„</span>
        </div>
        {/*<div className="col-10 col-lg-9 col-xl-7">*/}
        <div className="col-10 col-lg-6">
          {quote && (
            <h3 className={'quote-text'} data-scroll>
              {typeof quote === 'string' ? (
                <span dangerouslySetInnerHTML={{ __html: quote }} />
              ) : (
                quote
              )}
            </h3>
          )}
          {subline && (
            <p className={'quote-subline'} data-scroll>
              {typeof subline === 'string' ? (
                <span dangerouslySetInnerHTML={{ __html: subline }} />
              ) : (
                subline
              )}
            </p>
          )}
        </div>
      </div>
    </div>
  )
}
